import { getMutiStreetObjectDetection, getPeople } from '../../../api/elasticSearch/peopleApis'

const state = {
  peopleData: null,
  mutiStreetObjectDetection: null,
  objectTypes: null
}
const getters = {
  getPeopleData: state => {
    return state.peopleData
  },

  getMutiStreetObjectDetection: state => {
    return state.mutiStreetObjectDetection
  }
}
const actions = {
  async updatePeopleData({ commit }, condition) {
    commit('PeopleData', await getPeople(condition))
  },

  async updateMutiStreetObjectDetection({ commit }, condition) {
    commit('objectMutiStreetObjectDetection', await getMutiStreetObjectDetection(condition))
  }
}
const mutations = {
  PeopleData(state, data) {
    state.peopleData = data
  },

  objectMutiStreetObjectDetection(state, data) {
    state.mutiStreetObjectDetection = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
